import { Component, computed, effect } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { ErrorMessages } from '../../../shared/models/error-messages.model';
import { CONTRACT_START_TOO_EARLY } from '../../../config/error-messages.const';
import { ContractStartDateComponent } from '../contract-start-date/contract-start-date.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-contract-start-with-price',
    templateUrl: './contract-start-with-price.component.html',
    styleUrls: ['./contract-start-with-price.component.scss'],
    standalone: false,
})
export class ContractStartWithPriceComponent extends ContractStartDateComponent {
    private contractStart = toSignal(this.form.get('contractStart').valueChanges.pipe(distinctUntilChanged()));

    protected settlementPeriod = computed(() => this.insuranceType().settlementPeriod);
    protected taxInfo = computed(() => this.product().orderConfig.taxInfo);

    public contractStartError: ErrorMessages = {
        default: null,
        ageTooHigh: CONTRACT_START_TOO_EARLY,
    };

    public constructor(private _formBuilder: FormBuilder) {
        super(_formBuilder);

        // Update the price when the contract start date changes
        effect(() => {
            this.priceService.updatePrice({ contract: { ...this.contract, contractStart: this.contractStart() } });
        });
    }
}
